/**
 * Layout: Theme
 * -----------------------------------------------------------------------------
 * Entry file for all global theme scripts and registering sections and modules.
 *
 */
import '@/styles/theme.scss';
import { focusHash, bindInPageLinks } from '@shopify/theme-a11y';
import { load } from '@shopify/theme-sections';
import axios from 'axios';
/**
 * Global theme helpers.
 */

import { keyboardTabbable } from '~/helpers/a11y';
import AjaxCart from '~/helpers/ajax-cart';
import EventBus from '~/helpers/event-bus';
import Redirects from '~/helpers/redirects';
import { debounce, getBrowser, on } from '~/helpers/utils';
import ScrollDirection from '~/mixins/scroll-direction';
/**
 * Global theme section imports.
 */

import '~/sections/cart-drawer';
import '~/sections/menu-drawer';
import '~/sections/site-header';
/**
 * Global theme component imports.
 */

import CookieBanner from '~/components/cookie-banner';
import FreeShippingNotification from '~/components/free-shipping-notification';
import VideoPlayer from '~/components/video-player';
/**
 * Global Frame utils.
 */

window.Frame = window.Frame || {};
window.Frame.EventBus = EventBus();
document.addEventListener('DOMContentLoaded', () => {
  // Change z-index of Zendesk support chat,
  // so it is positioned bellow drawer cart.
  if (window.zE) {
    window.zE('webWidget', 'updateSettings', {
      webWidget: {
        zIndex: 23
      }
    });
  } else {
    window.zESettings = {
      webWidget: {
        zIndex: 23
      }
    };
  }

  if (getBrowser() === 'Internet Explorer') {
    axios.defaults.headers.common = {
      /**
       * IE11 caching bug.
       */
      Pragma: 'no-cache'
    };
  }
  /**
   * DOM selectors.
   */


  const selectors = {
    siteHeaderWrapper: '[js-site-header="wrapper"]',
    siteHeader: '[js-site-header="container"]'
  };
  /**
   * Instance globals.
   */

  let AnimatedHeader = {};
  /**
   * DOM node selectors.
   */

  const nodeSelectors = {
    siteHeaderWrapper: document.querySelector(selectors.siteHeaderWrapper),
    siteHeader: document.querySelector(selectors.siteHeader)
  };
  /**
   * Instantiate a collapsed header on scroll using scrollDirection helper.
   */

  function constructStickyHeader() {
    AnimatedHeader = ScrollDirection({
      throttle: 250,
      start: 100
    });
  }
  /**
   * Set sticky header events after document has loaded styling.
   */


  function setStickyHeader() {
    on('load', () => {
      AnimatedHeader.init();
      on('resize', debounce(() => handleResizeEvents(), 250));
    });
  }
  /**
   * Handle resize events by requesting animation frame.
   */


  function handleResizeEvents() {
    updateBodyOffset();
  }
  /**
   * Re-paint body padding-top using current header height.
   */


  function updateBodyOffset() {
    if (window.location.pathname !== '/') {
      document.body.style.paddingTop = "".concat(nodeSelectors.siteHeader.offsetHeight, "px");
    }
  }

  load('*');

  if (theme.features.stickyHeader) {
    setStickyHeader();
    constructStickyHeader();
  }

  AjaxCart().init();
  CookieBanner().init();
  keyboardTabbable().init();

  if (theme.features.redirectModal) {
    Redirects().init();
  }

  if (theme.features.freeShippingNotification) {
    FreeShippingNotification().init();
  } // Initialize video player if it exists,
  // Having it attempt to initialize on all pages guarantee it'll work even
  //   // on pages managed by third party apps like Boost


  VideoPlayer().init();
  focusHash();
  bindInPageLinks();
});